import { getIsFull } from '../../application/pageDataObject'
import LazyLoadService from '../services/LazyLoadService'
import { SELECTORS } from '../../config/preRenderedSelectorsConfig'
import { node, getSingleElementByClass, updateClassName } from '../../utils/dom'

const SECTION_TITLE_TOP_POSTS_AFTER_POST = 'section-title--top-posts-after-post'
const SECTION_TITLE_TOP_POSTS_SIDE_BAR = 'section-title--top-posts-side-bar'
const TOP_POSTS_AFTER_POST = 'top-posts-after-post'
const TOP_POSTS_SIDE_BAR = 'top-posts-side-bar'
const SECTION_TITLE = 'section-title'

function shouldShowTopPosts() {
  let postItem =
    node(SELECTORS.TOP_POSTS_AFTER_POST_ITEM_IMAGE_CONTAINER) ||
    node(SELECTORS.TOP_POSTS_SIDE_BAR_ITEM_IMAGE_CONTAINER)
  return getIsFull() && postItem
}

function shouldShowTopPostsAfterPosts() {
  let postAfter = node(SELECTORS.POST_AFTER)
  return postAfter.dataset.shouldShowRecommendations === '0'
}

function lazyLoadMedia(container, titleElement) {
  return (
    (container &&
      titleElement &&
      LazyLoadService.create({
        loadCallback: () => LazyLoadService.loadMedia(container),
        loadTriggerElement: titleElement,
      })) ||
    false
  )
}

function initLazyLoadAfterPost() {
  let container = getSingleElementByClass(TOP_POSTS_AFTER_POST)
  let titleElement = getSingleElementByClass(SECTION_TITLE_TOP_POSTS_AFTER_POST)
  return lazyLoadMedia(container, titleElement)
}

function initLazyLoadSideBar() {
  var container = getSingleElementByClass(TOP_POSTS_SIDE_BAR)
  var titleElement = getSingleElementByClass(SECTION_TITLE_TOP_POSTS_SIDE_BAR)
  return lazyLoadMedia(container, titleElement)
}

function showTopPostsAfterPost() {
  updateClassName(SELECTORS.TOP_POSTS_AFTER_POST, TOP_POSTS_AFTER_POST, '')
  var sectionTitleModifiers = {}
  sectionTitleModifiers[TOP_POSTS_AFTER_POST] = true
  updateClassName(
    SELECTORS.SECTION_TITLE_TOP_POSTS_AFTER_POST,
    SECTION_TITLE,
    sectionTitleModifiers
  )
}

function showTopPostsSideBar() {
  updateClassName(SELECTORS.TOP_POSTS_SIDE_BAR, TOP_POSTS_SIDE_BAR, '')
  var sectionTitleModifiers = {}
  sectionTitleModifiers[TOP_POSTS_SIDE_BAR] = true
  updateClassName(SELECTORS.SECTION_TITLE_TOP_POSTS_SIDE_BAR, SECTION_TITLE, sectionTitleModifiers)
}

function showTopPosts() {
  if (shouldShowTopPostsAfterPosts()) {
    initLazyLoadAfterPost()
    showTopPostsAfterPost()
  } else {
    showTopPostsSideBar()
    initLazyLoadSideBar()
  }
}

export default function handleTopPosts() {
  if (shouldShowTopPosts()) {
    showTopPosts()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initTopPosts.js